import { render, staticRenderFns } from "./SetShare.vue?vue&type=template&id=6444f268&"
import script from "./SetShare.vue?vue&type=script&lang=js&"
export * from "./SetShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports